import React from 'react';
import { BookData } from '../data/books';
import { ExternalLink } from 'lucide-react';
import { LazyImage } from './LazyImage';

interface BookCardProps {
  book: BookData;
}

export const BookCard: React.FC<BookCardProps> = ({ book }) => {
  const handleBookClick = () => {
    window.open(book.amazonUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className="book-card bg-white rounded-xl overflow-hidden shadow-lg h-full flex flex-col cursor-pointer transition-all duration-300 hover:shadow-xl hover:scale-105 border border-gray-100"
      onClick={handleBookClick}
    >
      <div className="relative h-64 bg-gray-100 overflow-hidden">
        <LazyImage
          src={book.coverUrl}
          alt={`${book.title} cover`}
          className="w-full h-full object-contain"
          placeholder="Loading..."
          width={300}
          height={400}
        />
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md">
          <ExternalLink size={14} className="text-gray-600" />
        </div>
      </div>
      
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">{book.title}</h3>
        <p className="text-sm text-purple-600 font-medium mb-3">{book.author}</p>
        <p className="text-sm text-gray-600 flex-grow leading-relaxed line-clamp-4">{book.description}</p>
        
        <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center">
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${
            book.category === 'manifestation' 
              ? 'bg-purple-100 text-purple-800' 
              : 'bg-blue-100 text-blue-800'
          }`}>
            {book.category === 'manifestation' ? 'Manifestation' : 'Motivational'}
          </span>
          
          <div className="flex items-center text-sm text-purple-600 font-semibold hover:text-purple-700 transition-colors">
            <span className="mr-1">View on Amazon</span>
            <ExternalLink size={14} />
          </div>
        </div>
      </div>
    </div>
  );
};